import React from 'react';
import './Banner.css';

const Banner = () => {
  return (
    <section className="banner">
      <h2 className="banner-title">COURSES DASHBOARD</h2>
    </section>
  );
};

export default Banner;
